import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Card,
	CardContent,
	Typography,
	Grid,
	Table,
	TableBody,
	TableRow,
	TableCell,
	Checkbox,
	InputAdornment,
	Button,
	FormGroup,
	FormControlLabel,
	TextField,
} from '@material-ui/core';
import {
	Delete as DeleteIcon,
	ReorderOutlined as ReorderIcon,
} from '@material-ui/icons';
import {
	MyPATTextArea,
	MyPATTextField,
	MyPATSelect,
	MyPATExpansionPanel,
	dateService,
	MyPATMathField,
	ModalComponent,
	AwardGraceMarks
} from '../../../common';

import Solution from './Solution';
import Hints from './Hints';
import AddExtraTags from './AddExtraTags';
import AddDifficultyAndSkill from './AddDifficultyAndSkill';
import RelevantExams from "./RelevantExams";
import AddConceptOrChapter from './AddConceptOrChapter';
// import BenchmarkQuestion from './BenchmarkQuestion';
import ContentSubtypeData from '../../types/ContentSubtypeData';
import ContentFormData, { OptionSettingsType } from '../../types/ContentFormData';
import ContentFormDataError from '../../types/ContentFormDataError';
import { CreateContentContentTagData } from '../../types/ContentTagData';
import { eventFired, paragraphEventFired } from '../../actions/contentInSectionAction'
import { statusType, ContentInSection, indexOfCommonSection } from '../../types/ContentInSection'
import QuestionTitleField from './QuestionTitleField';

import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import contentActions from '../../actions/contentActions';
import { CONTENT_SECTION_KEYS, CONTENT_SPECIAL_PURPOSES, CONTENT_STATES, CONTENT_TYPE, QUESTION_TYPES, TOTAL_QUESTION, USER_TYPE } from '../../../../constants/comman';
import AddBenchmarking from './AddBenchmarking';
import OptionSettings from './OptionSettings';
import { questionActions } from "../../reducers/questionCreateReducer";
import QuestionsSolution from './QuestionsSolution';
import { StepWiseSolution } from '../../types/ContentData';
import { convertTime } from '../../../../utils/getOffset.utils';
import VarientQuestionCard from './VarientQuestionCard';
import AddFeedback from "../../../content-request/components/AddFeedback";
import { addNewFeedback, resolveFeedback, replyFeedback } from "../../../content-request/actions/contentRequestActions";
import { SectionFocusedContext, SectionFocusedContextValue } from '../../../common/MyPATBaseSection';
import SetIdealTime from './SetIdealTime';
import PreviousYearQuestion from './PreviousYearQuestion';
import MatrixOptions from './MatrixOptions';
import MatrixAnswers from './MatrixAnswers';
import ContentOptions from './ContentOptions';
import ContentAnswer from './ContentAnswer';
import QuestionSlider from './QuestionSlider';
import CustomInfoIcon from '../../../common/CustomInfoIcon';
import { getPropertyValue, getUserType, validateBenchmarks } from '../../../../utils';
import AddFeedbackPopup from './AddFeedbackPopup';
import { SECTIONS } from '../../helper/contentValidation';
import RemedialQuestion from './RemedialComponent/RemedialQuestion';
import { REMEDIAL_KEY, remedialQuestionActions } from '../../reducers/remedialQuestionReducer';

const styles = (theme: Theme) =>
  createStyles({
    blueColor: {
      color: "#1D7DEA",
    },
    feedbackContainer: {
      position: "relative",
      "& .feedbackBlock": {
        top: -16,
        left: "100%",
        position: "absolute",
        marginLeft: 20,
        zIndex: 2,
      },
    },
    grayTxt: {
      color: "#999",
    },
    arrowIconB: {
      marginTop: "-4px",
      cursor: "pointer",
    },
    headingTxt: {
      fontSize: "14px",
      lineHeight: "16px",
      color: "#333",
    },
    optionContainerTxt: {
      margin: "24px 0 0px 0px",
    },
    optionSettingText: {
      width: "67px",
      margin: "0px 10px 0 10px",
      textAlign: "center",
      "& input": {
        padding: "10px",
      },
      "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, & input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
        opacity: 0,
      },
      "& input[type=number]": {
        "-moz-appearance": "textfield",
        appearance: "none",
      },
    },
    posRelative: {
      position: "relative",
    },
    arrowIcon: {
      position: "absolute",
      right: "8px",
      zIndex: 99,
    },
    arrowIconT: {
      cursor: "pointer",
    },
    mb1x: {
      marginBottom: theme.spacing.unit,
    },
    mb2x: {
      marginBottom: theme.spacing.unit * 2,
    },

    cardHeading: {
      fontWeight: theme.typography.fontWeightRegular,
    },
    requiredHeading: {
      color: theme.palette.secondary.main,
    },
    borderBox: {
      background: "#FFFFFF",
      border: "1px solid #E1E1E1",
      boxSizing: "border-box",
      // padding: theme.spacing.unit,
      borderRadius: 5,
      padding: 14,
      marginBottom: "14px",
    },
    checkboxChecked: {
      color: "#59CA1C !important",
    },

    subQuestionBox: {
      ...theme.mixins.gutters(),
      marginTop: theme.spacing.unit,
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
      paddingLeft: "0 !important",
      paddingRight: "0 !important",
    },
    borderFieldBox: {
      // border: `1px solid ${theme.palette.grey[300]}`,
      borderRadius: theme.shape.borderRadius,
    },
    boxHeading: {
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
      // borderBottom: `1px solid ${theme.palette.grey[300]}`,
      "& h6": {
        fontWeight: theme.typography.fontWeightRegular,
      },
    },
    boxField: {
      padding: "0 16px",
    },

    collapseBody: {
      background: theme.palette.grey[100],
    },
    collapseRoot: {
      marginBottom: theme.spacing.unit * 2,
    },
    marginLeft: {
      marginLeft: "15px",
    },
    optionColumn1: {
      paddingRight: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
    },
    adornedReorder: {
      cursor: "move",
      height: theme.spacing.unit * 4.5,
      padding: `0 ${theme.spacing.unit}px`,
      maxHeight: "unset",
      borderRight: `1px solid ${theme.palette.grey[300]}`,
      "& svg": {
        fontSize: theme.spacing.unit * 3,
        color: theme.palette.grey[500],
      },
    },
    deleteBtn: {
      border: `1px solid ${theme.palette.grey[300]}`,
      "& svg": {
        color: theme.palette.grey[600],
      },
    },
    addOptionButton: {
		height: 32,
		minWidth: 90,
		fontSize: 15,
		marginLeft: 30,
		marginBottom: 16,
    },

    answerTable: {
      width: "auto",
      marginTop: 15,
      "& tbody": {
        "& tr": {
          height: "auto",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "flex-start",
          alignItems: "center",
          "& td": {
            // padding: `${theme.spacing.unit / 2}px 0`,
            border: 0,
            textAlign: "center",
            minWidth: "70px",
            color: "#333",
            fontSize: 20,
            lineHeight: "38px",
            borderRight: "1px solid rgb(151 151 151 / 42%)",
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: "flex-start",
            height: 45,
            padding: '0 25px',
            width: 130,
            margin: "10px 0",
            "&:last-child": {
              border: "none",
            },
          },
          "&:first-child": {
            "& td": {
              borderRight: "1px solid rgb(151 151 151 / 42%)",
              fontSize: "20px",
              lineHeight: "38px",
              color: "#333",
              //   padding: '0 40px',
              "&:last-child": {
                borderRight: 0,
              },
              "&:nth-of-type(1)": {
                textAlign: "left",
                paddingLeft: 0,
                justifyContent: "flex-start",
              },
              "&:nth-of-type(6)": {
                textAlign: "left",
                paddingLeft: 0,
                justifyContent: "flex-start",
              },
              "&:nth-of-type(11)": {
                textAlign: "left",
                paddingLeft: 0,
                justifyContent: "flex-start",
              },
              "&:nth-of-type(16)": {
                textAlign: "left",
                paddingLeft: 0,
                justifyContent: "flex-start",
              },
              "&:nth-of-type(21)": {
                textAlign: "left",
                paddingLeft: 0,
                justifyContent: "flex-start",
              },
			  "&:nth-of-type(26)": {
                textAlign: "left",
                paddingLeft: 0,
                justifyContent: "flex-start",
              },
            },
          },
        },
      },
	  '& > td':{
		"&:nth-of-type(1)": {
			textAlign: "left",
			paddingLeft: 0,
			justifyContent: "flex-start",
		  },
	  }
    },

    cardContentRoot: {
      ...theme.mixins.gutters(),
      paddingTop: theme.spacing.unit * 2,
      paddingBottom: theme.spacing.unit * 2,
      "&:last-child": {
        paddingBottom: theme.spacing.unit * 2,
      },
    },

    addMoreQuestionWrapper: {
      textAlign: "right",
      marginBottom: theme.spacing.unit * 2,
    },

    optionField: {
      "& > div": {
        marginBottom: 0,
      },
    },
    optionIdGrid: {
      height: 45,
      display: "flex",
      minWidth: 32,
      alignItems: "center",
    },
    optionIdTitle: {
      fontSize: "16px",
      color: "#333",
      // fontWeight: 600,
    },
    optionContent: {
      "& .btn-delete": {
        visibility: "hidden",
      },
      "&:hover .btn-delete": {
        visibility: "visible",
      },
      "& .jodit_workplace": {
        border: "1px solid #dfdfdf !important",
        borderTopLeftRadius: "0 !important",
        borderBottomLeftRadius: "0 !important",
		maxHeight: '46px',
      },
    },
    reorderBtn: {
      border: "1px solid #dfdfdf !important",
      height: 46,
      padding: "0 8",
      minWidth: 55,
      borderRight: "none !important",
      marginBottom: 10,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      "& svg": {
        // color: theme.palette.grey[600],
        color: "#c4c4c4",
      },
    },

    deleteVBtn: {
		width: 48,
		border: "1px solid #e0e0e0 !important",
		height: 48,
		marginLeft: 10,
		minWidth: 32,
		background: "#fff",
      "& svg": {
        color: theme.palette.grey[600],
      },
    },
    paddingSet: {
      padding: "0 15px 0 0",
    },
    popupBlock: {
      width: "450px",
      textAlign: "center",
      "& p": {
        fontSize: "16px",
        "font-weight": "normal",
        lineHeight: "16px",
        textAlign: "center",
        letterSpacing: "0.144385px",
        color: "#000000",
        display: "block",
        paddingTop: "20px",
      },
    },
    attentionTitle: {
      fontSize: "16px",
      "font-weight": "500",
      lineHeight: "15px",
      textAlign: "center",
      letterSpacing: "0.144385px",
      color: "#000000",
      display: "block",
      paddingBottom: "18px",
    },
    spacingMD: {
      width: "calc(100% + 8px)",
      margin: "-10px 0px 0px",
      padding: "0px 0px 0px 10px",
    },
    mL13: {
      marginLeft: "13px",
    },
    feedbackHighlight: {
      cursor: "pointer",
      "&:hover": {
        color: "#1d7dea",
      },
    },
    checkedCheckbox: {
      backgroundColor: "#30BE76",
      border: "1px solid #30BE76 !important",
      borderRadius: 2,
      color: "#99a1a7",
      "&::after": {
        content: "''",
        fontSize: 14,
        position: "absolute",
        top: 3,
        left: 8,
        width: 4,
        height: 12,
        border: "solid #fff",
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)",
      },
      "&:hover": {
        backgroundColor: "#30BE76",
      },
    },
    checkBoxElement: {
      padding: "0px 7px",
      top: 6,
      width: 24,
      height: 24,
      "-moz-appearance": "none",
      opacity: 1,
      color: "rgb(204, 204, 204)",
      border: "1px solid #B2B2B2",
      borderRadius: 2,
      margin: "-15px 16px 0px 6px",
      right: 0,
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: '"Nunito", sans-serif',
        fill: "#979797",
        opacity: 0,
      },
	  '& span:nth-child(1)': {
		width: 24,
		zIndex: 9
	  }
    },
    primaryColor: {
      color: "rgb(29 125 234)",
    },
    setAnswerContainer: {
      marginBottom: "20px",
    },
	subTitle: {
		fontSize: 16,
		lineHeight: "22px",
		color: "#666",
		margin: "6px 0 10px 6px",
	},
	  blueStrip: {
		  borderRadius: '4px',
		  background: 'rgba(29, 125, 234, 0.10)',
		  boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.06)',
		  display: 'flex',
		  flexDirection: 'row',
		  alignItems: 'center',
		  justifyContent: 'space-between',
		  padding: '20px',
	  },
	  stripText: {
		  color: '#666',
		  fontSize: '18px',
		  fontStyle: 'normal',
		  fontWeight: 600,
		  lineHeight: '130%',
		  margin: 0,
	  },
	  stripCTA: {
		  color: '#1D7DEA',
		  fontSize: '16px',
		  fontStyle: 'normal',
		  fontWeight: 600,
		  lineHeight: '130%',
		  cursor: 'pointer'
	  },
  });

const questionTypes = [
	{ id: 0, name: "SMCQ" },
	{ id: 8, name: "MMCQ" },
	{ id: 2, name: "True & False"},
	{ id: 1, name: "Matrix"},
	{ id: 3, name: "Blanks"},
	{ id: 7, name: "Integer"},
	{ id: 6, name: "Numerical"},
	{ id: 4, name: "Descriptive"},
]

export const getQuestionTypeName = (typeCode: number) => {
	const questionType = questionTypes.find((questionType: any) => questionType.id == typeCode)
	return questionType && questionType.name
}

const optionsIdSet: string[] = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

interface ParagraphCreateProps extends WithStyles<typeof styles> {
	type: string,
	subType: string,
	formData: ContentFormData,
	formDataError: ContentFormDataError,
	eventFired: Function,
	paragraphEventFired: Function,
	handleFormChange: (formData: ContentFormData) => void,
	history: any;
	updateContent: Function;
	isValidAttempts: boolean;
	contentId: string;
	content: any;
	handleOptionSettingsChange: (type: string, value: any, options?: any) => void;
	initialiseNoOfStepWiseSolutionForQuestions: (noOfQuestions: number) => void;
	openFeedback: boolean;
	closeFeedback: Function;
	emptyClickedData: Function;
	authorType: string;
	contentRequestId: string;
	contentRequestItemId: string;
	addNewFeedback: Function;
	resolveFeedback: Function;
	replyFeedback: Function;
	clickedfeedbackData: any;
	handleFeedbackResolve: Function;
	feedbackData: any;
	fromFeedback: boolean;
	editRights: string[];
	relevantExams: any;
	optionsContent: any;
	matrixOptionContent: any;
	validations: any;
	isQuestionUpdated:boolean,
	questionSpecialPurposes: any;
	activeValidationFeedbackSection?: string;
	activeValidationFeedbackData?: number;
	handleAddCommentInFeedback?: Function;
	createNewValidationFeedback?: Function;
	selectedQuestionRef?: any;
	feedbackActionId?: string;
	setRemedialInitialState: Function;
	showRemedial: boolean;
}

interface ParagraphCreateState {
	isPageLoad: boolean;
	questionTypes: any,
	mathEditor: any,
	isOpen: boolean,
	idealTime: any,
	tag: string,
	selectedIndex: number,
	selectedQuestionIndex: number,
	addCommonRmedialQuestion: boolean,
}

class ParagraphCreate extends Component<ParagraphCreateProps, ParagraphCreateState> {
	isStudentUser: boolean = getUserType(USER_TYPE.STUDENT);

	constructor(props: ParagraphCreateProps) {
		super(props);
		this.state = {
			questionTypes: questionTypes,
			isPageLoad: true,
			mathEditor: null,
			isOpen: false,
			idealTime: { value: '', state: 1 },
			tag: "question",
			selectedIndex: 0,
			selectedQuestionIndex: 1,
			addCommonRmedialQuestion: false,
		};

		this.eventChanges = this.eventChanges.bind(this);
		this.handleDifficultyAndSkillFormChange = this.handleDifficultyAndSkillFormChange.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.addNewFeedback = this.addNewFeedback.bind(this);
		this.resolveFeedback = this.resolveFeedback.bind(this);
		this.replyFeedback = this.replyFeedback.bind(this);
		this.closeFeedback = this.closeFeedback.bind(this);
		this.addFeedback = this.addFeedback.bind(this);
		this.checkFeedback = this.checkFeedback.bind(this);

	}
	addFeedback(tagName: string, index?: number) {
		if (!_.isEmpty(this.props.clickedfeedbackData)) {
			this.props.emptyClickedData();
		}
		let clickedfeedbackData = this.props.feedbackData && this.props.feedbackData.feedbacksData && this.props.feedbackData.feedbacksData.filter((feedback: any) =>
			feedback.tag === tagName && !feedback.isResolved && feedback.contentId === _.get(this.props.content, 'content.content[' + index + '].paragraphQuestionId', '')
		);
		if (clickedfeedbackData && clickedfeedbackData.length > 0) {
			this.props.handleFeedbackResolve(clickedfeedbackData[0])
		}
		setTimeout(() => {

			if (this.props.openFeedback) {
				if (index !== undefined) {
					this.setState({
						tag: tagName,
						selectedIndex: index
					})
				} else {
					this.setState({
						tag: tagName,
					})
				}
			}
		}, 200);


	}
	closeFeedback() {
		this.props.closeFeedback()
	}
	addNewFeedback(text: string) {
		let feedbackData = {
			contentRequestId: this.props.contentRequestId,
			contentId: _.get(this.props.content, 'content.content[' + this.state.selectedIndex + '].paragraphQuestionId', ''),
			comment: text,
			role: this.props.authorType,
			tag: this.state.tag,
			contentRequestItemId: this.props.contentRequestItemId,
			contentType: 'question'
		}
		this.props.addNewFeedback(feedbackData)
		this.props.closeFeedback('resolve');
		this.setState({
			tag: 'question',
			selectedIndex: 0	
			})
	}
	resolveFeedback(id: string) {
		let feedbackData = {
			feedbackId: id,
			role: this.props.authorType,
			contentRequestItemId: this.props.contentRequestItemId,
			contentType: 'question'
		}
		this.props.resolveFeedback(feedbackData)
		this.props.closeFeedback('resolve');
		this.setState({
			tag: 'question',
			selectedIndex: 0	
			})
	}
	replyFeedback(id: string, text: string) {
		let feedbackData = {
			feedbackId: id,
			contentRequestId: this.props.contentRequestId,
			contentId: _.get(this.props.content, 'content.content[' + this.state.selectedIndex + '].paragraphQuestionId', ''),
			comment: text,
			role: this.props.authorType,
			tag: this.state.tag,
			contentRequestItemId: this.props.contentRequestItemId,
			contentType: 'question'
		}
		this.props.replyFeedback(feedbackData)
		this.props.closeFeedback('resolve');
		this.setState({
			tag: 'question',
			selectedIndex: 0	
			})
	}
	addFeedbackFromSolution(update: string, index: number) {
		this.addFeedback('solution', index)
	}

	componentDidMount() {
		setTimeout(() => {
			this.props.eventFired('questionContent', statusType.edit, 0, 'paragraph')
			setTimeout(() => {
				this.props.eventFired('passageQuestion', statusType.edit, '0', 'paragraph');
			}, 17000)
			const localStorageValue: any = localStorage.getItem('isPassageData');
			if (localStorageValue) {
				setTimeout(() => {
					this.handleCommonTypeForRequestPreSelected();
				}, 5000)
				setTimeout(() => {
					this.handleSelectOptionForPreSelected();
				}, 5000)
				localStorage.setItem('isPassageData', '')
			}
		}, 5000)

		const self = this
		/* TODO: uncomment later when data loss issue fix for all functions */
		// const {formData} = this.props
		window.onbeforeunload = function (e: any) {
			const { formData } = self.props
			self.props.handleFormChange(formData)
			e.preventDefault()
			e.returnValue = ''
		}
		// if(this.props.contentRequestId){

		// }
		/* TODO: uncomment later */
		// let idealTime = _.get(this.props.formData.content[index], 'settings.idealTime', {})
		// this.setState({idealTime: {...idealTime}})
		if (this.props.selectedQuestionRef) {
			this.props.selectedQuestionRef.current = this.findQuestionAndSetActiveQuestion;
		}
		const totalQuestion = getPropertyValue(this.props.formData, 'totalQuestion', 0);
		totalQuestion && this.props.setRemedialInitialState(+totalQuestion);
	}

	setMathInstance = (mathEditor: any) => {
		this.setState({ mathEditor })
	}

	handleInputChange = (i: any, evt: any) => {
		const { name, value } = evt.target;
		let { formData } = this.props;

		if (_.isUndefined(formData.content[i])) {
			formData.content.push({ [name]: value });
		} else {
			formData.content[i][name] = value;
		}

		this.transferToParent();
		this.eventChanges(name, i);
	}

	handleStepWiseSolutionChange = (i: number) => (value: StepWiseSolution[]) => {
		let { formData } = this.props;
		const name = 'stepWiseSolution';
		if (_.isUndefined(formData.content[i])) {
			formData.content.push({ [name]: value });
		} else {
			formData.content[i][name] = value;
		}

		this.transferToParent();

		setTimeout(() => {
			this.eventChanges(name, i);
		}, 0);
	}

	handleAddConceptChapterFormChange(i: any, updatedSubjects: any, subjectType: 'subjects' | 'secondarySubjects') {
		let { formData } = this.props;
		const updatedData = { ...formData };
		const updatedContent = [...updatedData.content];
		updatedContent[i] = { ...updatedContent[i], [subjectType]: [...updatedSubjects] };
		updatedData.content = updatedContent;


		this.transferToParent(updatedData);
		this.eventChanges('conceptCode', i);

	}

	handleAddConceptChapterFormCourseChange(i: any, courses: any) {
		let { formData } = this.props;
		const updatedData = { ...formData };
		const updatedContent = [...updatedData.content];
		updatedContent[i].syllabusExams = [...courses];
		updatedData.content = updatedContent;
		this.transferToParent(updatedData);
		this.eventChanges('conceptCode', i);
	}

	handleDifficultyAndSkillFormChange(index: any, difficulty: any, skill: any) {
		let { formData } = this.props;

		if (_.isUndefined(formData.content[index])) {
			formData.content.push({ difficultyLevel: difficulty, difficultyType: skill })
		}
		else {
			formData.content[index]['difficultyLevel'] = difficulty;
			formData.content[index]['difficultyType'] = skill;
		}

		formData.content[index]['difficultyLevel'] = difficulty;
		formData.content[index]['difficultyType'] = skill;

		this.props.handleFormChange(formData);
	}

	handleBenchmarkingFormChange = (benchmarks: any, i: any) => {
		let { formData } = this.props;
		let updateFormData = JSON.parse(JSON.stringify(formData))
		updateFormData.content[i].benchmarks = benchmarks;
		this.transferToParent(updateFormData);
		this.eventChanges('addBenchmarking', i);
	}

	handleRelevantExamsChange = (
		relevantExams: any[]
	) => {
		const { formData } = this.props;
		const updatedFormData = {...formData};
		updatedFormData.relevantExams = relevantExams;
		this.transferToParent(updatedFormData);
	}

	handleAddOptionClick(i: any) {
		let { formData } = this.props;
		let newOptionSet = {
			id: optionsIdSet[0],
			value: '',
			serialNo: 1,
		};

		if (_.isUndefined(formData.content[i].optionsContent)) {
			const content = formData.content[i];
			formData.content[i] = {
				...content,
				optionsContent: [],
				correctAnswer: {
					answerType: 'id',
					data: [],
				}
			};
		}

		if (!_.isEmpty(formData.content[i].optionsContent)) {
			const optionsContent = _.get(formData.content[i], 'optionsContent', []);
			if (optionsContent.length >= 26) {
				return;
			}
			newOptionSet.id = optionsIdSet[optionsContent.length];
			newOptionSet.serialNo = optionsContent.length + 1;
		}

		formData.content[i].optionsContent.push(newOptionSet);
		this.transferToParent();

	}

	handleDeleteOptionClick = (i: any, idx: any, id: string, evt: any) => {
		let { formData } = this.props;
		let optionsContent: any[] = _.get(formData.content[i], 'optionsContent', []);
		let optionSettings: OptionSettingsType = _.get(formData.content[i], 'settings.option', []);
		if (optionsContent.length === optionSettings.displayCount) {
			return;
		}
		let correctAnswer: any[] = _.get(formData.content[i], 'correctAnswer.data', []);
		let newOptionsContent: any[] = [];

		// remove option from index
		optionsContent.splice(idx, 1);

		// reset option id and serial no
		if (!_.isEmpty(optionsContent)) {
			let noId: any[] = [];

			optionsContent.forEach((option: any, index: number) => {
				option.id = optionsIdSet[index];
				option.serialNo = index + 1;

				noId.push(option.id);
				newOptionsContent.push(option);
			})

			correctAnswer = correctAnswer.filter((data: any) => {
				noId.includes(data.value);
			})
		} else {
			correctAnswer = [];
		}

		formData.content[i].correctAnswer.data = correctAnswer;
		formData.content[i].optionsContent = newOptionsContent;
		this.transferToParent();
	}

	handleOptionValueChange(i: any, index: any, evt: any) {
		let { formData } = this.props;
		formData.content[i].optionsContent[index].value = evt.target.value;

		this.transferToParent();
		this.eventChanges('optionsContent', i);

	}

	handleTagsFormChange(tagsFormData: CreateContentContentTagData[], evt: any) {
		let { formData } = this.props;
		formData.tags = tagsFormData;

		this.transferToParent();
		this.eventChanges('tags', 0);

	}

	handleSelectOption(evt: any) {
		const { name, value } = evt.target;
		let { formData, matrixOptionContent }: any = this.props;
		const updatedFormData = { ...formData };
		updatedFormData[name] = value;
		formData.content[0] = {
			...formData.content[0],
			subjects: [],
			optionsContent: this.getOptionsContent(formData.content[0].typeOfQuestion),
			matrixOptionContent: formData.content[0].typeOfQuestion === "1" ? matrixOptionContent :  [],
			correctAnswer: {
				answerType: 'id',
				data: []
			},
			customAnswer: false,
			alternateAnswer: false,
			settings: {
				...formData.content[0].settings,
				option: {
					displayCount: 4,
					shuffleType: 'same'
				}
			}
		}
		this.transferToParent(updatedFormData);
		
		if (name === TOTAL_QUESTION) {
			this.props.setRemedialInitialState(+value);
			this.pushQuestionContent(value, false, evt);
		}
	}
    getOptionsContent(quesType: any) {
		let { optionsContent } = this.props;

		if(quesType === "1") {
			return []
		}else if (quesType === "2") {
            return [
				{ id: "A", value: "True", serialNo: 1 },
				{ id: "B", value: "False", serialNo: 2 }
			  ]
		} 
			return optionsContent
		

	}
	pushQuestionContent(by: any, isAdd: boolean, e: any) {
		let { formData, optionsContent, matrixOptionContent } = this.props;
		let contentLength = formData.content.length;
		this.props.initialiseNoOfStepWiseSolutionForQuestions(by);
		if (contentLength <= 30) {
			let toBePushed = by - contentLength;
			toBePushed = isAdd ? 1 : toBePushed;
			if (toBePushed > 0) {
				for (let i = 0; i < toBePushed; i++)
					formData.content.push({
						active:false,
						subjects: [],
						typeOfQuestion: formData.content[0].typeOfQuestion,
						optionsContent: this.getOptionsContent(formData.content[0].typeOfQuestion),
						matrixOptionContent: formData.content[0].typeOfQuestion === "1" ? matrixOptionContent :  [],
						correctAnswer: {
							answerType: 'id',
							data: []
						},
						customAnswer: false,
						alternateAnswer: false,
						settings: {
							option: {
								displayCount: 4,
								shuffleType: 'same'
							},
							idealTime: { value: '', state: 2 },
						}
					});
			}
			else {
				formData.content.splice(by, contentLength)
			}
			formData.totalQuestion = formData.content.length;
		}
		setTimeout(() => {
			this.transferToParent();
			this.eventChanges("totalQuestion", 0);
		}, 0);
	}

	handleCorrectOptionChange(i: any, optionId: string, evt: any, checked: boolean) {
		let { formData } = this.props;
		const typeOfQuestion = _.get(formData.content, '[0].typeOfQuestion', -1);
		const alternateAnswer = _.get(formData.content, '[0].alternateAnswer', false);
		//for mmcq
		if (typeOfQuestion == '8' || alternateAnswer) {
			if (checked) {
				formData.content[i].correctAnswer.data.push({ value: optionId });
			} else {
				formData.content[i].correctAnswer.data = formData.content[i].correctAnswer.data.filter((v: any) => v.value != optionId);
			}
		} else {
			// for smcq
			if (checked) {
				formData.content[i].correctAnswer = {
					answerType: 'id',
					data: [{ value: optionId }]
				}
			} else {
				formData.content[i].correctAnswer = {
					answerType: 'id',
					data: []
				}
			}
		}

		this.transferToParent();
		this.eventChanges('correctAnswer', i);

	}
	handleCommonType(e: any) {
		let { name, value } = e.target;
		const { formData } = this.props;

		if (formData.content) {
			formData.content.forEach((con: any, i: number) => {
				if (name === 'typeOfQuestion') {
					con["typeOfQuestion"] = value
				}
				if (name === 'passageQuestion') {
					con["passageQuestion"] = value
				}
			})
		};
	}
	handleSelectOptionForPreSelected() {
		const localStorageValue: any = localStorage.getItem('passageData');
		const localStorageVal = JSON.parse(localStorageValue);
		const { count: value = 0 } = localStorageVal;
		let { formData }: any = this.props;
		const updatedFormData = { ...formData };
		updatedFormData['totalQuestion'] = String(value);
		formData.content[0] = {
			...formData.content[0],
			settings: {
				...formData.content[0].settings,
				option: {
					displayCount: 4,
					shuffleType: 'same'
				}
			}
		}
		this.transferToParent(updatedFormData);
		this.pushQuestionContent(value, false, '');
		this.props.setRemedialInitialState(+value);
	}

	handleCommonTypeForRequestPreSelected() {
		const localStorageValue: any = localStorage.getItem('passageData');
		const localStorageVal = JSON.parse(localStorageValue);
		const { code: value = '', count = 0 } = localStorageVal;
		let name = 'typeOfQuestion'
		const { formData } = this.props;

		if (formData.content) {
			formData.content.forEach((con: any, i: number) => {

				if (name === 'typeOfQuestion') {
					con["typeOfQuestion"] = value
					con['active'] = false;
				}
				if (name === 'passageQuestion') {
					con["passageQuestion"] = value
				}
			})
		};
		this.transferToParent();
		this.eventChanges(name, 0, value);

	}

	transferToParent(updatedFormData?: any) {
		let { formData } = this.props;
		const data = updatedFormData || formData;
		this.props.handleFormChange(data);
	}

	isPageLoad(e: any) {
		this.setState({
			isPageLoad: false
		});
	}

	eventChanges(name: any, i: any, value: any = "") {
		let innerSection = ['questionContent', 'optionsContent', 'correctAnswer', 'stepWiseSolution', 'questionHints', 'conceptCode'];
		if (['passageQuestion', 'tags'].includes(name)) {
			this.props.eventFired(name, statusType.edit, "0", 'paragraph');
		} else if (innerSection.includes(name)) {
			this.props.eventFired(name, statusType.edit, i, 'paragraph');
		}
		else if (['typeOfQuestion', 'totalQuestion'].includes(name)) {
			let { formData } = this.props;
			let v = questionTypes.filter(ob => ob.id == _.get(formData, 'content[0].typeOfQuestion', -1))[0].name;
			this.props.paragraphEventFired({ typeOfQuestion: v, noOfQuestion: formData.content.length });
		}
	}

	isAnswerChecked = (i: number, id: string) => {
		const { formData } = this.props;
		let hasId = false;
		_.get(formData, `content[${i}].correctAnswer.data`, []).forEach((ca: any) => {
			if (ca.value == id) {
				hasId = true;
			}
		})

		return hasId;
	}

	draggedItem: any = {};
	onDragStart = (evt: any, i: number, index: number) => {
		const optionsContent: any[] = _.get(this.props.formData, `content[${i}].optionsContent`, []);
		this.draggedItem = optionsContent[index];
		evt.dataTransfer.effectAllowed = 'move';
		evt.dataTransfer.setData("text/html", evt.target.parentNode);
		evt.dataTransfer.setDragImage(evt.target.parentNode, 20, 20);
	}

	onDragOver = (i: number, index: number) => {
		let { formData } = this.props;
		let optionsContent: any[] = _.get(this.props.formData, `content[${i}].optionsContent`, []);
		let newOptionsContent: any[] = [];
		const draggedOverItem = optionsContent[index];

		if (this.draggedItem.id === draggedOverItem.id) {
			return;
		}

		optionsContent = optionsContent.filter((item: any) => item.id !== this.draggedItem.id);
		optionsContent.splice(index, 0, this.draggedItem);

		optionsContent.forEach((option: any, index: number) => {
			option.id = optionsIdSet[index];
			option.serialNo = index + 1;
			newOptionsContent.push(option);
		})

		formData.content[i].correctAnswer.data = [];
		formData.content[i].optionsContent = newOptionsContent;
		this.transferToParent();
	}

	onDragEnd = () => {
		this.draggedItem = {};
	}

	handleClose = () => {
		const { history } = this.props
		history.push("/");
	}

	/* TODO: uncomment later */
	_setIdealTimeChange = (value: any, state: string, index: number) => {
		const { formData } = this.props
		formData.content[index].settings.idealTime = { value, state }
		this.props.handleFormChange(formData)
	}

	getTimerState(state: number) {
		if (state === 2) return 'min'
		else if (state === 3) return 'hour'
		return 'sec'
	}

	onChangeIdealTime = (e: any, index: number, newState?: number) => {
		var regex = /^\d+$/
		const { formData } = this.props
		let idealTime = _.get(formData.content[index], 'settings.idealTime', {})
		let idealTimeValue = _.get(idealTime, 'value', '')
		let value = e ? e.target.value : idealTimeValue
		if (value === '' || regex.test(value)) {
			value = value ? parseInt(value) : value
			let { state: currState } = idealTime
			if(newState) {
				currState = newState;
			}
			/* TODO: uncomment later */
			// value = convertTime(
			//     value, 
			//     this.getTimerState(e ? currState : this.state.idealTime.state), 
			//     this.getTimerState(currState))
			// value = value ? parseInt(value) : value
			if (currState >= 1 && currState <= 3) {
				/* TODO: uncomment later */
				// if(e) {
				//     this.setState({idealTime: {value, state: currState}},
				//         () =>  this._setIdealTimeChange(value, currState, index))
				// } else {
				this._setIdealTimeChange(value, currState, index)
				// }
			}
		}
	}

	renderIdealTimeState(index: number) {
		const { formData } = this.props
		const { idealTime } = formData.content[index].settings
		if (idealTime.state === 2) {
			return 'Min'
		} else if (idealTime.state === 3) {
			return 'Hour'
		} else if (idealTime.state === 1) {
			return 'Sec'
		}
	}

	optionSettingsChange = (type: string, value: any, index: number) => {
		this.props.handleOptionSettingsChange(type, value, { isParagraph: true, index });
		setTimeout(() => {
			if (type === 'displayCount' && value !== '') {
				const optionsContent = this.props.formData.content[index].optionsContent
				const noOfOptionsDiff = value - optionsContent.length
				if (noOfOptionsDiff > 0) {
					for (let i = 0; i < noOfOptionsDiff; i++) {
						this.handleAddOptionClick(index);
					}
				}
			}
		}, 0)
	}

	renderDifficultyLevel = (c: any) => {
		const { formData } = this.props
		if (formData.masterVariationQuestionId) {
			return formData.difficultyLevel
		} else {
			return _.get(c, 'difficultyLevel', []);
		}
	}

	renderDifficultyType = (c: any) => {
		const { formData } = this.props
		if (formData.masterVariationQuestionId) {
			return formData.difficultyType
		} else {
			return _.get(c, 'difficultyType', [])



		}
	}

	returnQuestionType = (questionType: any) => {
		return <>
			<option value={-1}> Select type of question </option>
			{_.map(questionType, (data, index) =>
				<option key={index} value={data.id}>{data.name}</option>
			)}
		</>
	}

	returnSelectQuestion = (questionTypes: any) => {
		return <>
			<option value={-1}> Select type of question </option>
			{_.map(questionTypes, (data, index) =>
				<option key={index} value={data.id}>{data.name}</option>
			)}
		</>

	}

	returnCountOfQuestion = (count: number) => {
		return <option value={count}> {count} </option>
	}

	returnNoOfQuestion = (noQs: any) => {
		return <>
			<option value={0}> Select No. of Questions </option>
			{_.map(noQs, (noQ, index) =>
				<option key={index} value={noQ}>{noQ}</option>
			)}</>

	}

	checkFeedback(c: any, i: number, tag: string) {
		const { clickedfeedbackData } = this.props;
		return ((_.isEmpty(clickedfeedbackData) && this.props.openFeedback && this.state.tag === tag &&
			this.state.selectedIndex === i) || (!_.isEmpty(clickedfeedbackData) && this.props.openFeedback && clickedfeedbackData.tag === tag && c.paragraphQuestionId === clickedfeedbackData.contentId))
	}

	_setMatrixOptionContent = (obj: any, i: number) => {
		const { matrixOptionContent } = obj;

		let { formData } = this.props;
		let updateFormData = JSON.parse(JSON.stringify(formData))

		updateFormData.content[i].matrixOptionContent = matrixOptionContent;
		this.transferToParent(updateFormData);

	  };
	
	  _setMatrixCorrectAnswer = (value: any, i: number) => {
		let { formData } = this.props;
		let updateFormData = JSON.parse(JSON.stringify(formData))
		updateFormData.content[i].correctAnswer = value;
		this.transferToParent(updateFormData);
		this.eventChanges('correctAnswer',i)
	  };
	  _setCustomAnswer = (value: any, i: number) => { 
		let { formData } = this.props;
		let updateFormData = JSON.parse(JSON.stringify(formData))
		updateFormData.content[i].customAnswer = value;
		this.transferToParent(updateFormData);
	  };

	  _setAlternateAnswer = (value: any, i: number) => {	  
		let { formData } = this.props;
		let updateFormData = JSON.parse(JSON.stringify(formData))
		updateFormData.content[i].alternateAnswer = value;
		this.transferToParent(updateFormData);
	  };
	  _setOptionSettings = (type: string, value: any, i: number) => {
		  let { formData, subType } = this.props;
		  let updateFormData = JSON.parse(JSON.stringify(formData))
		  let optionSettings = {
            ...updateFormData.content[i].settings.option,
						  [type]: value,
			  subType,
		  }
		  updateFormData.content[i].settings.option = optionSettings;
		  this.transferToParent(updateFormData);

	  };

	  _setOptionContent = (value: any, i: number) => {    
		let { formData } = this.props;
		let updateFormData = JSON.parse(JSON.stringify(formData))

		updateFormData.content[i].optionsContent = value;
		this.transferToParent(updateFormData);

	  };

	findQuestionAndSetActiveQuestion = (contentId: string) => {
		const { formData: { content } } = this.props;
		(content || []).some((contentInfo: any, index: number) => {
			if (contentId === contentInfo.contentId) {
				this.setState({
					selectedQuestionIndex: index + 1
				})
				return true;
			}
			return false;
		})
	}

	setQuestionActive = (val: any) => {
		let name = 'questionContent'
		this.setState({
			selectedQuestionIndex: parseInt(val)
		})
		this.eventChanges(name, parseInt(val) - 1)
	}

	stepwiseSolutionCheck(stepWiseSolution: any) {
		let checkValue = true;
		stepWiseSolution.forEach((element: any) => {
			if (!element.formulaUsed.length && element.solutionSteps.length) {
				element.solutionSteps.forEach((ele: any) => {
					if (!ele.solution.length) {
						checkValue = false;
					}
				});
			}
		});
		return checkValue
	}
    checkOptionContent(optionsContent:any){
        let checkValue = true;
	  optionsContent.forEach((element:any) => {
            if(!element.value.length){
                checkValue = false;
            }
        });
        return checkValue
    }
	getSliderContentArray(questionArray: any[]) {
		const { subType } = this.props
		let contentType = _.get(this.props.formData, 'content[0].typeOfQuestion', -1);
		questionArray.forEach((element: any) => {
			if (parseInt(subType) <= 4) {
				if ((element.correctAnswer && element.correctAnswer.data && element.correctAnswer.data.length) && (element.questionContent && element.questionContent.length) && element.questionHints &&
					element.questionHints.length && this.checkOptionContent(element.optionsContent) && element.subjects.length && this.stepwiseSolutionCheck(element.stepWiseSolution)) {
					element.active = true;
				} else {
					element.active = false;
				}
			} else {
				// the optional requirement for descriptive type has been handled through the below check
				if (subType === '5' && contentType === '4') {

					if ((element.questionContent && element.questionContent.length) && element.questionHints &&
						element.questionHints.length && element.subjects.length && this.stepwiseSolutionCheck(element.stepWiseSolution)) {
						element.active = true;
					} else {
						element.active = false;
					}
				} else {

					if ((element.correctAnswer.data ? ((element.correctAnswer.data.length && element.correctAnswer.data[0].value) ? (element.correctAnswer.data[0].value.toString().length) : false) : element.correctAnswer[0].value)&& (element.questionContent && element.questionContent.length) && element.questionHints &&
						element.questionHints.length && element.subjects.length && this.stepwiseSolutionCheck(element.stepWiseSolution)) {
						element.active = true;
					} else {
						element.active = false;
					}
				}
			}
		});
		return questionArray
	}
	handleCommonRemedialQuestion = (value: boolean) => {
		this.setState({
			addCommonRmedialQuestion: value
		})
	}
	renderCommonRemedialSelectCta = () => {
		const { classes, showRemedial } = this.props;
		if (!showRemedial) return null;
		return (
			<div className={classes.blueStrip}>
				<span className={classes.stripText}>
					To add common remedial question(s) to all the sub-questions of this paragraph.
				</span>
				<span className={classes.stripCTA} onClick={() => this.handleCommonRemedialQuestion(true)}>
					Click Here
				</span>
			</div>
		)
	}
	render() {
		const { classes, formData, isValidAttempts, formDataError, type, subType, content: _content, contentId,
			clickedfeedbackData, handleOptionSettingsChange, openFeedback, editRights, questionSpecialPurposes,
			activeValidationFeedbackSection, handleAddCommentInFeedback, activeValidationFeedbackData, createNewValidationFeedback , feedbackActionId, showRemedial} = this.props;
		let { isPageLoad, questionTypes, isOpen, tag, selectedIndex, selectedQuestionIndex } = this.state;
		const { content } = formData;
		let questionType = questionTypes;
		let count = 0;
		const localStorageValue: any = localStorage.getItem('passageData');
		if (localStorageValue && !this.props.fromFeedback) {
			const localStorageVal = JSON.parse(localStorageValue);
			const { type: questionTypeData = '', countData = 0, code = '0' } = localStorageVal;
			let typeOfQuestion: any = [];
			typeOfQuestion.push({
				id: Number(code),
				name: questionTypeData
			});
			questionType = typeOfQuestion;
			count = countData;
		}
		const lockData = _.get(formData, 'lockData')
		let isLock = false
		let message = ''
		if (lockData) {
			isLock = lockData.isLock
			message = lockData.message
		}
		let questionId = contentId ? contentId.split('question')[0] : contentId;

		//@ts-ignore
		if (formData.passageInfo && formData.passageInfo.totalQuestion > 0) {
			//@ts-ignore
			formData.totalQuestion = formData.passageInfo.totalQuestion
		}
		formData.totalQuestion = _content.masterVariationQuestionId
			? _content.masterVariationQuestionData.totalQuestion
			: formData.totalQuestion
		let noQs = _.range(2, 26);
		let c = content[selectedQuestionIndex - 1]
		let questionArray: any[] = this.getSliderContentArray(formData.content)
		const isFtre = questionSpecialPurposes.includes(CONTENT_SPECIAL_PURPOSES.FTRE);
		const isAitsOrNationalLevel = questionSpecialPurposes.includes(CONTENT_SECTION_KEYS.NATIONAL_LEVEL_TEST) || questionSpecialPurposes.includes(CONTENT_SECTION_KEYS.AITS);
		const isGlorifire = !isFtre && !isAitsOrNationalLevel;
		const studentUser = getUserType(USER_TYPE.STUDENT);
		return (
			<>
				{
					_content.masterVariationQuestionId && (
						<VarientQuestionCard content={_content}
							title={_.isUndefined(content[0]) ? '' : content[0].passageQuestion} />
					)
				}
				<MyPATExpansionPanel
					isDisable={!editRights.includes('content')}
					hasExpandIcon
					variant="white"
					sectionId="createScenario"
					showErrorOnTouch
					customCollapseTitle={
						<Typography variant="h6" className={classes.cardHeading}>
							Create Scenario<span className={classes.requiredHeading}>*</span>
						</Typography>
					}
				>
					<QuestionTitleField
						changeHandler={this.handleCommonType.bind(this)}
						name="passageQuestion"
						inputId="createQuestion"
						type={type}
						subType={subType}
						formData={formData}
						value={_.isUndefined(content[0]) ? '' : content[0].passageQuestion}
						error={formDataError['content'].error}
						errorText={formDataError['content'].errorText}
					/>

					<div className={`${classes.borderBox} ${classes.subQuestionBox}`}>
						<Grid container spacing={16}>
							<Grid item xs={6}>
								<div className={classes.borderFieldBox}>
									<div className={classes.boxHeading}>
										<Typography variant="subtitle2">
											Type of Questions
											<span className={classes.requiredHeading}>*</span>
										</Typography>
									</div>
									<div className={classes.boxField}>
										<MyPATSelect
											inputId="tyeOfQuestions"
											name="typeOfQuestion"
											value={content.length > 0 ? content[0].typeOfQuestion : -1}
											required
											onChange={this.handleCommonType.bind(this)}
											fullWidthControl
											disabled={_.get(content, '[0].typeOfQuestion', -1) != -1}
										>
											{questionType ? this.returnQuestionType(questionType) : this.returnSelectQuestion(questionTypes)}
										</MyPATSelect>
									</div>
								</div>
							</Grid>
							<Grid item xs={6}>
								<div className={classes.borderFieldBox}>
									<div className={classes.boxHeading}>
										<Typography variant="subtitle2">No. of Questions</Typography>
									</div>
									<div className={classes.boxField}>
										<MyPATSelect
											inputId="totalQuestion"
											name="totalQuestion"
											value={_.isUndefined(formData.totalQuestion) ? 0 : formData.totalQuestion}
											open
											fullWidthControl
											onChange={this.handleSelectOption.bind(this)}
											disabled={!!formData.totalQuestion || _.get(content, '[0].typeOfQuestion', -1) === -1}
										>
											{count ? this.returnCountOfQuestion(count) : this.returnNoOfQuestion(noQs)}
										</MyPATSelect>
									</div>
								</div>
							</Grid>
						</Grid>
					</div>
				</MyPATExpansionPanel>

				{
					formData.totalQuestion && formData.totalQuestion > 0 && _.get(content, '[0].typeOfQuestion', -1) != -1 ?
						<>
							{this.renderCommonRemedialSelectCta()}
							<QuestionSlider totalQuestion={questionArray} setQuestionActive={this.setQuestionActive.bind(this)} activeIndex={this.state.selectedQuestionIndex}></QuestionSlider>
						</>
						: <></>
				}
				{
					formData.totalQuestion && formData.totalQuestion > 0 && _.get(content, '[0].typeOfQuestion', -1) != -1 ?

						<MyPATExpansionPanel key={selectedQuestionIndex - 1}
							collapseTitle={`${questionTypes[_.findIndex(questionTypes, { id: (_.get(content, '[0].typeOfQuestion', -1) ? parseInt(_.get(content, '[0].typeOfQuestion', -1)) : 0) })].name} Question No. ${selectedQuestionIndex}`}
							variant="white"
							onClick={this.isPageLoad.bind(this)}
							defaultExpanded={true}>

							<MyPATExpansionPanel
								isDisable={!editRights.includes('content')}
								hasExpandIcon
								variant="white"
								sectionId={`createQuestion-${selectedQuestionIndex}`}
								customCollapseTitle={<>

									<Typography variant="h6" className={classes.cardHeading} onClick={(event) => {
										event.stopPropagation();
										this.addFeedback('question', selectedQuestionIndex - 1)
									}}>
										<span
											id={this.checkFeedback(content[selectedQuestionIndex - 1], selectedQuestionIndex - 1, 'question') ? 'feedbackScroll' : ''}
											className={`${classes.feedbackContainer} ${this.checkFeedback(c, selectedQuestionIndex - 1, 'question') ? classes.blueColor : ''} ${this.props.openFeedback ? classes.feedbackHighlight : ''}`}
										>Create Question
										<span className={classes.requiredHeading}>*  </span> 
											{this.checkFeedback(content[selectedQuestionIndex - 1], selectedQuestionIndex - 1, 'question') && (
												<Grid className="feedbackBlock">
													<AddFeedback
														author={this.props.authorType}
														replyFeedback={this.replyFeedback} closeFeedback={this.closeFeedback} resolveFeedback={this.resolveFeedback} clickedfeedbackData={clickedfeedbackData} addNewFeedback={this.addNewFeedback} />
												</Grid>)}
												{
                activeValidationFeedbackSection === SECTIONS.CONTENT && (
                  <AddFeedbackPopup isAuthor={true} allowFeedbacks={true} handleAdd={handleAddCommentInFeedback} handleCancel={()=>createNewValidationFeedback && createNewValidationFeedback('')} feedbackData={activeValidationFeedbackData} feedbackActionId={feedbackActionId} />
                )
              }
										</span>
										<CustomInfoIcon
											infoDialogContentType="Goal Management"
											isInfoIcon={true}
											isRightArrow={false}
											isCenterArrow={true}
											knowMoreAbout={false}
											dialogTitle="Create Question"
											imageURL="/assets/svg/infoIcon/createQuestion.svg"
											dialogPara="Create a question by entering text, pasting an image, or using the formatting toolbar at the top."
											details="Click to know more"
											toolTipDirection="top" />
									</Typography></>
								}
							>
								<MyPATMathField
									variant='textarea'
									editorProps={{
										externalToolbarId: 'box',
										name: `questionContent`,
										handleChange: this.handleInputChange.bind(this, selectedQuestionIndex - 1),
										setInstance: this.setMathInstance,
										editorId: `questionContent${selectedQuestionIndex - 1}`,
										value: _.isUndefined(c) ? '' : c.questionContent,
										placeholder: 'Enter text'
									}}
								/>
								{/* <Typography variant="caption" align="right" color="textSecondary">
										Draft saved: {dateService.dateTime(formData.updatedAt)}
									</Typography> */}
							</MyPATExpansionPanel>
							{(_.get(content, '[0].typeOfQuestion', 0) === "0" || _.get(content, '[0].typeOfQuestion', 0) === "8") && (<>
								<MyPATExpansionPanel
									isDisable={!editRights.includes('options')}
									hasExpandIcon
									variant="white"
									sectionId={`options-${selectedQuestionIndex}`}
									showErrorOnTouch
									customCollapseTitle={
										<Typography variant="h6" className={classes.cardHeading} onClick={(event) => {
											event.stopPropagation();
											this.addFeedback('options', selectedQuestionIndex - 1)
										}}>
											<span
												id={this.checkFeedback(c, selectedQuestionIndex - 1, 'options') ? 'feedbackScroll' : ''}
												className={`${classes.feedbackContainer} ${this.checkFeedback(c, selectedQuestionIndex - 1, 'options') ? classes.blueColor : ''} ${this.props.openFeedback ? classes.feedbackHighlight : ''}  `}
											>Options<span className={classes.requiredHeading}>*</span>
												{this.checkFeedback(c, selectedQuestionIndex - 1, 'options') && (
													<Grid className="feedbackBlock">
														<AddFeedback
															author={this.props.authorType}
															replyFeedback={this.replyFeedback} closeFeedback={this.closeFeedback} resolveFeedback={this.resolveFeedback} clickedfeedbackData={clickedfeedbackData} addNewFeedback={this.addNewFeedback} />
													</Grid>
												)}
											</span>
											<CustomInfoIcon
												infoDialogContentType="Goal Management"
												isInfoIcon={true}
												isRightArrow={false}
												isCenterArrow={true}
												knowMoreAbout={false}
												dialogTitle="Options"
												imageURL="/assets/svg/infoIcon/options.svg"
												dialogPara="Add options by entering text, pasting an image, or using the formatting toolbar at the top <br/><br/>
												Click on the Icon <img src='/assets/svg/infoIcon/sequence.svg'/> and drag the selections for resequencing as per your preferences <br/><br/>
												You can also remove any option by clicking the Delete button that appears when you hover over it"
												details="Click to know more"
												toolTipDirection="top" />


										</Typography>
									}
									error={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].optionsContent.error`, false)}
									errorText={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].optionsContent.errorText`, "")}
								>

									{content[selectedQuestionIndex - 1] && c.settings && c.settings.option &&
										<OptionSettings
											subType={_.get(content, '[0].typeOfQuestion', 0)}
											optionSettings={c.settings.option}
											handleOptionSettingsChange={(type: string, value: any) => this.optionSettingsChange(type, value, selectedQuestionIndex - 1)}
											tag={tag}
											openFeedback={openFeedback}
											addFeedback={this.addFeedback}
											replyFeedback={this.replyFeedback}
											closeFeedback={this.closeFeedback}
											resolveFeedback={this.resolveFeedback}
											clickedfeedbackData={clickedfeedbackData}
											addNewFeedback={this.addNewFeedback}
											selectedIndex={selectedIndex}
											questionIndex={selectedQuestionIndex - 1}
											questionId={c.paragraphQuestionId}
											authorType={this.props.authorType}

										/>}
									<div className={classes.borderBox}>
										<Grid container className={classes.mb1x}>

											<Grid item xs={12} className={classes.optionColumn1}>
												<Typography variant="subtitle1" className={classes.mb2x}>
													Define Option List
												</Typography>
												{content[selectedQuestionIndex - 1] && _.map(c.optionsContent, (option, index: number) => (
													<Grid className={classes.optionContent} key={index} container spacing={8} justify="space-between" alignItems="center"
														onDragOver={() => this.onDragOver(selectedQuestionIndex - 1, index)
														}
													>
														{/* <Grid item xs="auto" className={classes.optionIdGrid}>
														<Typography variant="subtitle1" align="center">
															{option.id}
														</Typography>
													</Grid> */}
														<Grid item xs draggable
															className={classes.optionField}

														>
															<Grid>
																<MyPATMathField
																	gridSize={9}
																	editorProps={{
																		externalToolbarId: 'box',
																		name: 'optionsContent',
																		value: option.value,
																		editorId: `editor_${selectedQuestionIndex - 1}${index}`,
																		handleChange: this.handleOptionValueChange.bind(this, selectedQuestionIndex - 1, index),
																		setInstance: this.setMathInstance,
																		placeholder: `Add option ${index + 1} (Enter Option Text or Paste Image)`
																	}}
																	startAdorment={
																		<Grid item xs="auto">
																			<Grid container>
																				<Grid item xs="auto" className={classes.optionIdGrid}>
																					<Typography variant="subtitle1" noWrap className={classes.optionIdTitle}>
																						{option.id}
																					</Typography>
																				</Grid>
																				<Grid item xs="auto"
																					draggable
																					onDragStart={(e) => this.onDragStart(e, selectedQuestionIndex - 1, index)}
																					onDragEnd={this.onDragEnd}
																				>
																					<Button variant="outlined" className={classes.reorderBtn}>
																						<ReorderIcon />
																					</Button>
																				</Grid>
																			</Grid>
																		</Grid>
																	}
																	endAdorment={
																		<Grid item xs={1}>
																			{
																				subType != '2' && (
																					<Grid item xs="auto">
																						<Button variant="outlined" className={classes.deleteVBtn + "  btn-delete"}
																							disabled={c.settings && c.settings.option && (c.optionsContent.length === c.settings.option.displayCount)}
																							onClick={this.handleDeleteOptionClick.bind(this, selectedQuestionIndex - 1, index, option.id)}
																						>
																							<img src="/assets/svg/myLibrary/delete-outline.svg" />
																							{/* <DeleteIcon /> */}
																						</Button>
																					</Grid>
																				)
																			}
																		</Grid>
																	}
																/>
															</Grid>
														</Grid>
														{/* <Grid item xs="auto">
														<Button variant="outlined" className={classes.deleteBtn + "  btn-delete"}
															onClick={this.handleDeleteOptionClick.bind(this, selectedQuestionIndex, index, option.id)}
														>
															<DeleteIcon />
														</Button>
													</Grid> */}
													</Grid>
												))}
											</Grid>
										</Grid>
										<Grid>
											<Button
												variant="contained"
												size="small"
												color="primary"
												className={classes.addOptionButton}
												onClick={this.handleAddOptionClick.bind(this, selectedQuestionIndex - 1)}
											>
												+ Add
											</Button>
										</Grid>
									</div>
								</MyPATExpansionPanel>
								<MyPATExpansionPanel
									isDisable={!editRights.includes('answer')}
									hasExpandIcon
									variant="white"
									sectionId={`answer-${selectedQuestionIndex}`}
									customCollapseTitle={
										<>

											<Typography variant="h6" className={classes.cardHeading} onClick={(event) => {
												event.stopPropagation();
												this.addFeedback('answer', selectedQuestionIndex - 1)
											}}>
												<span
													id={this.checkFeedback(c, selectedQuestionIndex - 1, 'answer') ? 'feedbackScroll' : ''}
													className={`${classes.feedbackContainer} ${this.checkFeedback(c, selectedQuestionIndex - 1, 'answer') ? classes.blueColor : ''} ${this.props.openFeedback ? classes.feedbackHighlight : ''}`}
												>Answer<span className={classes.requiredHeading}>*</span>
													{this.checkFeedback(c, selectedQuestionIndex - 1, 'answer') && (
														<Grid className="feedbackBlock">
															<AddFeedback
																author={this.props.authorType}
																replyFeedback={this.replyFeedback} closeFeedback={this.closeFeedback} resolveFeedback={this.resolveFeedback} clickedfeedbackData={clickedfeedbackData} addNewFeedback={this.addNewFeedback} />
														</Grid>)}
												</span>
												<CustomInfoIcon
										infoDialogContentType="Goal Management"
										isInfoIcon={true}
										isRightArrow={false}
										isCenterArrow={true}
										knowMoreAbout={false}
										dialogTitle="Answer"
										imageURL="/assets/svg/infoIcon/answer.svg"
										dialogPara="Specify the correct answer(s) to the question"
										details="Click to know more"
										toolTipDirection="top" />
											</Typography>
										</>
									}
									error={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].correctAnswer.error`, false)}
									errorText={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].correctAnswer.errorText`, "")}
									showErrorOnTouch
								>
									<SectionFocusedContext.Consumer>
										{({ setSectionFocus }: SectionFocusedContextValue) => (
											<div>
												<Grid container
													justify="space-between"
													alignItems="center" spacing={8}>
													<Grid item>
														<Typography variant="subtitle1" className={classes.subTitle}>Set Correct Answer</Typography>
													</Grid>
													<Grid item>
														{
															formData.status === CONTENT_STATES.PUBLISHED && isValidAttempts &&
															<AwardGraceMarks
																alternateAnswer={_.get(formData, `content[${selectedQuestionIndex - 1}].alternateAnswer`, false)}
																setAlternateAnswer={(alternateAnswer: boolean) => {
																	formData.content[selectedQuestionIndex - 1].alternateAnswer = alternateAnswer
																	this.props.handleFormChange(formData)
																}}
																correctAnswer={_.get(formData, `content[${selectedQuestionIndex - 1}].correctAnswer`, false)}
																changeHandler={(_correctAnswer: any) => {
																	formData.content[selectedQuestionIndex - 1].correctAnswer = _correctAnswer
																	this.props.handleFormChange(formData)
																}}
															/>
														}
													</Grid>
												</Grid>
												<Table className={classes.answerTable}>
													<TableBody>
														{/* <TableRow>
															{_.map(c.optionsContent, (option, index) => <TableCell key={index}>{option.id}</TableCell>)}
														</TableRow> */}
														<TableRow>
															{c && _.map(c.optionsContent, (option, index) => (
																<TableCell key={index}>
																	<Checkbox
																		name="correctAnswer"
																		checked={this.isAnswerChecked(selectedQuestionIndex - 1, option.id)}
																		classes={{
																			root: classes.checkBoxElement,
																			checked: classes.checkedCheckbox,
																			colorPrimary: classes.primaryColor
																		}}
																		onChange={this.handleCorrectOptionChange.bind(this, selectedQuestionIndex - 1, option.id)}
																		onFocus={() => setSectionFocus(true)}
																		onBlur={() => setSectionFocus(false)}
																	/>
																	{option.id}
																</TableCell>
															))}
														</TableRow>
													</TableBody>
												</Table>
											</div>
										)}
									</SectionFocusedContext.Consumer>
								</MyPATExpansionPanel>

							</>)}
							{
								_.get(content, '[0].typeOfQuestion', 0) === "1" && (
									<>
										<MatrixOptions
											changeHandler={(e: any) => this._setMatrixOptionContent(e, selectedQuestionIndex - 1)}
											name="contentOption"
											inputId="createQuestion"
											type={type}
											subType={subType}
											matrixOptionContent={_.get(content[selectedQuestionIndex - 1], 'matrixOptionContent', {})}
											matrixCorrectAnswer={_.get(content[selectedQuestionIndex - 1], 'correctAnswer', {})}
											optionSettings={_.get(content[selectedQuestionIndex - 1], 'settings.option', {})}
											handleOptionSettingsChange={(typeVal: string, shuffle: any) => this._setOptionSettings(typeVal, shuffle, selectedQuestionIndex - 1)}
											error={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].matrixOptionContent.error`, false)}
											errorText={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].matrixOptionContent.errorText`, "")}
											tag={tag}
											openFeedback={openFeedback}
											addFeedback={this.addFeedback}
											replyFeedback={this.replyFeedback}
											closeFeedback={this.closeFeedback}
											resolveFeedback={this.resolveFeedback}
											clickedfeedbackData={clickedfeedbackData}
											addNewFeedback={this.addNewFeedback}
											selectedIndex={selectedIndex}
											questionId={c.paragraphQuestionId}
											authorType={this.props.authorType}
											questionIndex={selectedQuestionIndex - 1}
											sectionId={`options-${selectedQuestionIndex}`}
											isDisable={!editRights.includes('options')}
											activeValidationFeedbackSection={activeValidationFeedbackSection}
											activeValidationFeedbackData={activeValidationFeedbackData}
											handleAddCommentInFeedback={handleAddCommentInFeedback}
											createNewValidationFeedback={createNewValidationFeedback}
										/>
										<MatrixAnswers
											changeHandler={(e: any) => this._setMatrixCorrectAnswer(e, selectedQuestionIndex - 1)}
											name="matrixAnswer"
											inputId="createQuestion"
											type={type}
											subType={subType}
											matrixOptionContent={_.get(content[selectedQuestionIndex - 1], 'matrixOptionContent', {})}
											matrixCorrectAnswer={_.get(content[selectedQuestionIndex - 1], 'correctAnswer', {})}
											onChangeIdealTime={this._setIdealTimeChange}
											idealTime={_.get(content[selectedQuestionIndex - 1], 'settings.idealTime', {})}
											error={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].correctAnswer.error`, false)}
											errorText={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].correctAnswer.errorText`, "")}
											tag={tag}
											openFeedback={openFeedback}
											addFeedback={this.addFeedback}
											replyFeedback={this.replyFeedback}
											closeFeedback={this.closeFeedback}
											resolveFeedback={this.resolveFeedback}
											clickedfeedbackData={clickedfeedbackData}
											addNewFeedback={this.addNewFeedback}
											selectedIndex={selectedIndex}
											questionId={c.paragraphQuestionId}
											authorType={this.props.authorType}
											questionIndex={selectedQuestionIndex - 1}
											isDisable={!editRights.includes('answer')}
											isIdealTimeDisabled={!editRights.includes('idealTime')}
											hideIdealTIme={true}
											sectionId = {`answer-${selectedQuestionIndex}`}
											activeValidationFeedbackSection={activeValidationFeedbackSection}
											activeValidationFeedbackData={activeValidationFeedbackData}
											handleAddCommentInFeedback={handleAddCommentInFeedback}
											createNewValidationFeedback={createNewValidationFeedback}
										/>
									</>
								)
							}

							{(_.get(content, '[0].typeOfQuestion', 0) === "2" || _.get(content, '[0].typeOfQuestion', 0) === "3" || _.get(content, '[0].typeOfQuestion', 0) === "4" || _.get(content, '[0].typeOfQuestion', 0) === "6" || _.get(content, '[0].typeOfQuestion', 0) === "7") && (
								<>
									<ContentOptions
										changeHandler={(e: any) => this._setOptionContent(e, selectedQuestionIndex - 1)}
										name="contentOption"
										inputId="createQuestion"
										type={type}
										subType={_.get(content, '[0].typeOfQuestion', 0)}
										optionsContent={_.get(content[selectedQuestionIndex - 1], 'optionsContent', {})}
										optionSettings={_.get(content[selectedQuestionIndex - 1], 'settings.option', {})}
										handleOptionSettingsChange={(typeVal: string, shuffle: any) => this._setOptionSettings(typeVal, shuffle, selectedQuestionIndex - 1)}
										error={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].optionsContent.error`, false)}
										errorText={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].optionsContent.errorText`, "")}
										tag={tag}
										openFeedback={openFeedback}
										addFeedback={this.addFeedback}
										replyFeedback={this.replyFeedback}
										closeFeedback={this.closeFeedback}
										resolveFeedback={this.resolveFeedback}
										clickedfeedbackData={clickedfeedbackData}
										addNewFeedback={this.addNewFeedback}
										selectedIndex={selectedIndex}
										questionId={c.paragraphQuestionId}
										authorType={this.props.authorType}
										questionIndex={selectedQuestionIndex - 1}
										isDisable={!editRights.includes('options')}
										activeValidationFeedbackSection={activeValidationFeedbackSection}
										activeValidationFeedbackData={activeValidationFeedbackData}
										handleAddCommentInFeedback={handleAddCommentInFeedback}
										createNewValidationFeedback={createNewValidationFeedback}

									/>
									<ContentAnswer
										customAnswer={_.get(content[selectedQuestionIndex - 1], 'customAnswer', false)}
										updateCustomAnswer={(e: any) => this._setCustomAnswer(e, selectedQuestionIndex - 1)}
										changeHandler={(e: any) => this._setMatrixCorrectAnswer(e, selectedQuestionIndex - 1)}
										isValidAttempts={this.props.isValidAttempts}
										onChangeIdealTime={this._setIdealTimeChange}
										idealTime={_.get(content[selectedQuestionIndex - 1], 'settings.idealTime', {})}
										name="contentAnswer"
										inputId="createQuestion"
										type={type}
										subType={_.get(content, '[0].typeOfQuestion', 0)}
										//status={status}
										alternateAnswer={_.get(content[selectedQuestionIndex - 1], 'alternateAnswer', false)}
										setAlternateAnswer={(e: any) => this._setAlternateAnswer(e, selectedQuestionIndex - 1)}
										optionsContent={_.get(content[selectedQuestionIndex - 1], 'optionsContent', {})}
										correctAnswer={c.correctAnswer}
										error={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].correctAnswer.error`, false)}
										errorText={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].correctAnswer.errorText`, "")}
										tag={tag}
										openFeedback={openFeedback}
										addFeedback={this.addFeedback}
										replyFeedback={this.replyFeedback}
										closeFeedback={this.closeFeedback}
										resolveFeedback={this.resolveFeedback}
										clickedfeedbackData={clickedfeedbackData}
										addNewFeedback={this.addNewFeedback}
										selectedIndex={selectedIndex -1}
										questionId={c.paragraphQuestionId}
										authorType={this.props.authorType}
										questionIndex={selectedQuestionIndex - 1}
										isDisable={!editRights.includes('answer')}
										isIdealTimeDisabled={!editRights.includes('idealTime')}
										hideIdealTIme={true}
										sectionId= {`answer-${selectedQuestionIndex}`}
										activeValidationFeedbackSection={activeValidationFeedbackSection}
										activeValidationFeedbackData={activeValidationFeedbackData}
										handleAddCommentInFeedback={handleAddCommentInFeedback}
										createNewValidationFeedback={createNewValidationFeedback}
									/>
								</>
							)}
							{(_.get(content, '[0].typeOfQuestion', 0) === "4") && (
								<>
									<AddConceptOrChapter
										sectionId={`mapSyllabus-${selectedQuestionIndex}`}
										formData={content[selectedQuestionIndex - 1] ? _.isUndefined(c.subjects) ? [] : c.subjects : []}
										handleFormChange={(subjects: any) => { this.handleAddConceptChapterFormChange(selectedQuestionIndex - 1, subjects, 'subjects') }}
										allowSecondarySubjects
										secondarySubjects={content[selectedQuestionIndex - 1] ? _.isUndefined(c.secondarySubjects) ? [] : c.secondarySubjects : []}
										handleSecondarySubjectChange={(data: any) => { this.handleAddConceptChapterFormChange(selectedQuestionIndex - 1, data, 'secondarySubjects') }}
										handleCourseChange={(data: any) => { this.handleAddConceptChapterFormCourseChange(selectedQuestionIndex - 1, data) }}
										error={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].subjects.error`, false)}
										errorText={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].subjects.errorText`, "")}
										isDisable={(content.masterVariationQuestionId || !editRights.includes('syllabus')) ? true : false}
										tag={tag}
										openFeedback={openFeedback}
										addFeedback={this.addFeedback}
										replyFeedback={this.replyFeedback}
										closeFeedback={this.closeFeedback}
										resolveFeedback={this.resolveFeedback}
										clickedfeedbackData={clickedfeedbackData}
										addNewFeedback={this.addNewFeedback}
										questionIndex={selectedQuestionIndex - 1}
										selectedIndex={selectedIndex}
										questionId={content[selectedQuestionIndex - 1] ? c.paragraphQuestionId : ''}
										authorType={this.props.authorType}
										contentType={CONTENT_TYPE.QUESTION}
										goalMandatory
										activeValidationFeedbackSection={activeValidationFeedbackSection}
										activeValidationFeedbackData={activeValidationFeedbackData}
										handleAddCommentInFeedback={handleAddCommentInFeedback}
										createNewValidationFeedback={createNewValidationFeedback}
									/>
								</>
							)}

							<QuestionsSolution
								sectionId={`solution-${selectedQuestionIndex}`}
								onChange={this.handleStepWiseSolutionChange(selectedQuestionIndex - 1)}
								subType={subType}
								questionIndex={selectedQuestionIndex - 1}
								error={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].stepWiseSolution.error`, false)}
								errorText={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].stepWiseSolution.errorText`, "")}
								tag={tag}
								openFeedback={openFeedback}
								addFeedback={this.addFeedback}
								replyFeedback={this.replyFeedback}
								closeFeedback={this.closeFeedback}
								resolveFeedback={this.resolveFeedback}
								clickedfeedbackData={clickedfeedbackData}
								addNewFeedback={this.addNewFeedback}
								selectedIndex={selectedIndex}
								questionId={content[selectedQuestionIndex - 1] ? c.paragraphQuestionId : ''}
								authorType={this.props.authorType}
								isDisable={!editRights.includes('solution')}
								activeValidationFeedbackSection={activeValidationFeedbackSection}
								activeValidationFeedbackData={activeValidationFeedbackData}
								handleAddCommentInFeedback={handleAddCommentInFeedback}
								createNewValidationFeedback={createNewValidationFeedback}
							/>
							{/* <MyPATMathField
										variant='textarea'
										editorProps={{
											externalToolbarId: 'box',
											name: "solutionContent",
											handleChange: this.handleInputChange.bind(this, i),
											setInstance: this.setMathInstance,
											editorId: `solutions${i}`,
											value: _.isUndefined(c.solutionContent) ? '' : c.solutionContent
										}}
									/> */}

							{/* <Solution
								formData={_.isUndefined(c.solutionContent) ? '' : c.solutionContent}
								handleFormChange={this.handleInputChange.bind(this, i)}
								isRequired
								index = {i}
								error={_.get(formDataError, `questions[${i}].solutionContent.error`, false)}
								errorText={_.get(formDataError, `questions[${i}].solutionContent.errorText`, "")}
							/> */}

							{/* TODO: need to fix paragraph functionality */}
							{/* <ParagraphHintsComponent  /> */}
							{(_.get(content, '[0].typeOfQuestion', 0) !== "4") && (
								<>
									<AddConceptOrChapter
										sectionId={`mapSyllabus-${selectedQuestionIndex}`}
										formData={content[selectedQuestionIndex - 1] ? _.isUndefined(c.subjects) ? [] : c.subjects : []}
										handleFormChange={(subjects: any) => { this.handleAddConceptChapterFormChange(selectedQuestionIndex - 1, subjects, 'subjects') }}
										allowSecondarySubjects
										handleCourseChange={(data: any) => { this.handleAddConceptChapterFormCourseChange(selectedQuestionIndex - 1, data) }}
										secondarySubjects={content[selectedQuestionIndex - 1] ? _.isUndefined(c.secondarySubjects) ? [] : c.secondarySubjects : []}
										handleSecondarySubjectChange={(data: any) => { this.handleAddConceptChapterFormChange(selectedQuestionIndex - 1, data, 'secondarySubjects') }}
										error={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].subjects.error`, false)}
										errorText={_.get(formDataError, `questions[${selectedQuestionIndex - 1}].subjects.errorText`, "")}
										isDisable={(content.masterVariationQuestionId || !editRights.includes('syllabus')) ? true : false}
										tag={tag}
										openFeedback={openFeedback}
										addFeedback={this.addFeedback}
										replyFeedback={this.replyFeedback}
										closeFeedback={this.closeFeedback}
										resolveFeedback={this.resolveFeedback}
										clickedfeedbackData={clickedfeedbackData}
										addNewFeedback={this.addNewFeedback}
										questionIndex={selectedQuestionIndex - 1}
										selectedIndex={selectedIndex}
										questionId={content[selectedQuestionIndex - 1] ? c.paragraphQuestionId : ''}
										authorType={this.props.authorType}
										contentType={CONTENT_TYPE.QUESTION}
										goalMandatory
										activeValidationFeedbackSection={activeValidationFeedbackSection}
										activeValidationFeedbackData={activeValidationFeedbackData}
										handleAddCommentInFeedback={handleAddCommentInFeedback}
										createNewValidationFeedback={createNewValidationFeedback}
									/>
								</>
							)}

							{ !isGlorifire && !this.isStudentUser &&
								<AddBenchmarking
									defaultExpanded={true}
									questionId={content[selectedQuestionIndex - 1] ? c.paragraphQuestionId : ''}
									subjects={content[selectedQuestionIndex - 1] ? _.isUndefined(c.subjects) ? [] : c.subjects : []}
									isDisable={(content.masterVariationQuestionId || !editRights.includes('benchmarking')) ? true : false}
									handleFormChange={(b: any) => this.handleBenchmarkingFormChange(b,selectedQuestionIndex - 1)}
									activeValidationFeedbackSection={activeValidationFeedbackSection}
									activeValidationFeedbackData={activeValidationFeedbackData}
									handleAddCommentInFeedback={handleAddCommentInFeedback}
									createNewValidationFeedback={createNewValidationFeedback}
								/>
							}
							<AddDifficultyAndSkill
								defaultExpanded={false}
								formData={formData}
								from='paragraphCreate'
								// difficultyLevel={_.isUndefined(c['difficultyLevel']) ? [] : c['difficultyLevel']}
								difficultyLevel={this.renderDifficultyLevel(c)}
								difficultyType={this.renderDifficultyType(c)}
								// difficultyType={_.isUndefined(c['difficultyType']) ? [] : c['difficultyType']}
								handleFormChange={this.handleDifficultyAndSkillFormChange.bind(this, selectedQuestionIndex - 1)}
								tag={tag}
								openFeedback={openFeedback}
								addFeedback={this.addFeedback}
								replyFeedback={this.replyFeedback}
								closeFeedback={this.closeFeedback}
								resolveFeedback={this.resolveFeedback}
								clickedfeedbackData={clickedfeedbackData}
								addNewFeedback={this.addNewFeedback}
								questionIndex={selectedQuestionIndex - 1}
								selectedIndex={selectedIndex}
								questionId={content[selectedQuestionIndex - 1] ? c.paragraphQuestionId : ''}
								authorType={this.props.authorType}
								isDisable={(content.masterVariationQuestionId || !editRights.includes('difficulty')) ? true : false}
								isNotMandatory={isFtre || studentUser}
								activeValidationFeedbackSection={activeValidationFeedbackSection}
								activeValidationFeedbackData={activeValidationFeedbackData}
								handleAddCommentInFeedback={handleAddCommentInFeedback}
								createNewValidationFeedback={createNewValidationFeedback}
							/>

							{!this.isStudentUser &&
								<SetIdealTime
									addFeedback={this.addFeedback}
									openFeedback={this.props.openFeedback}
									checkFeedback={() => this.checkFeedback(c, selectedQuestionIndex - 1, 'idealTime')}
									idealTime={formData.content[selectedQuestionIndex - 1].settings.idealTime}
									isDisable={!editRights.includes('idealTime')}
									onChangeIdealTime={(e: any, newState?: number) => this.onChangeIdealTime(e, selectedQuestionIndex - 1, newState)}
									authorType={this.props.authorType}
									replyFeedback={this.replyFeedback}
									closeFeedback={this.closeFeedback}
									resolveFeedback={this.resolveFeedback}
									clickedfeedbackData={clickedfeedbackData}
									addNewFeedback={this.addNewFeedback}
									activeValidationFeedbackSection={activeValidationFeedbackSection}
									activeValidationFeedbackData={activeValidationFeedbackData}
									handleAddCommentInFeedback={handleAddCommentInFeedback}
									createNewValidationFeedback={createNewValidationFeedback}
								/>
							}

							{!this.isStudentUser &&
								<Hints
									sectionId={`hints-${selectedQuestionIndex}`}
									formData={content[selectedQuestionIndex - 1] ? _.isUndefined(c.questionHints) ? '' : c.questionHints : ''}
									handleFormChange={this.handleInputChange.bind(this, selectedQuestionIndex - 1)}
									inputId="hints"
									tag={tag}
									openFeedback={openFeedback}
									addFeedback={this.addFeedback}
									replyFeedback={this.replyFeedback}
									closeFeedback={this.closeFeedback}
									resolveFeedback={this.resolveFeedback}
									clickedfeedbackData={clickedfeedbackData}
									addNewFeedback={this.addNewFeedback}
									selectedIndex={selectedIndex}
									questionIndex={selectedQuestionIndex - 1}
									questionId={content[selectedQuestionIndex - 1] ? c.paragraphQuestionId : ''}
									authorType={this.props.authorType}
									placeholder="Describe the hint that leads to solution"
									isDisable={!editRights.includes('hints')}
									isOptional={true}
									activeValidationFeedbackSection={activeValidationFeedbackSection}
									activeValidationFeedbackData={activeValidationFeedbackData}
									handleAddCommentInFeedback={handleAddCommentInFeedback}
									createNewValidationFeedback={createNewValidationFeedback}
								/>
							}

							{!this.isStudentUser &&
								<RelevantExams
									isOptional={true}
									relevantExams={this.props.relevantExams}
									defaultExpanded={false}
									handleRelevantExamsChange={this.handleRelevantExamsChange}
									isDisable={(content.masterVariationQuestionId || !editRights.includes('relevantExams')) ? true : false}
									tag={tag}
									openFeedback={openFeedback}
									addFeedback={this.addFeedback}
									replyFeedback={this.replyFeedback}
									closeFeedback={this.closeFeedback}
									resolveFeedback={this.resolveFeedback}
									clickedfeedbackData={clickedfeedbackData}
									addNewFeedback={this.addNewFeedback}
									questionIndex={selectedQuestionIndex}
									selectedIndex={selectedIndex}
									questionId={content[selectedQuestionIndex - 1] ? c.paragraphQuestionId : ''}
									authorType={this.props.authorType}
									activeValidationFeedbackSection={activeValidationFeedbackSection}
									activeValidationFeedbackData={activeValidationFeedbackData}
									handleAddCommentInFeedback={handleAddCommentInFeedback}
									createNewValidationFeedback={createNewValidationFeedback}
								/>
							}

							{ isGlorifire && !this.isStudentUser &&
							<AddBenchmarking
								questionId={content[selectedQuestionIndex - 1] ? c.paragraphQuestionId : ''}
								subjects={content[selectedQuestionIndex - 1] ? _.isUndefined(c.subjects) ? [] : c.subjects : []}
								isDisable={(content.masterVariationQuestionId || !editRights.includes('benchmarking')) ? true : false}
								activeValidationFeedbackSection={activeValidationFeedbackSection}
								activeValidationFeedbackData={activeValidationFeedbackData}
								handleAddCommentInFeedback={handleAddCommentInFeedback}
								createNewValidationFeedback={createNewValidationFeedback}
							/>
							}
							{showRemedial && !this.isStudentUser && <RemedialQuestion QuestionId={content[selectedQuestionIndex - 1] ? c.paragraphQuestionId : ''} QuestionTypeCode={+subType} remedialKey={`${REMEDIAL_KEY.REMEDIAL}${selectedQuestionIndex}`} addCommonRemedialQuestion={this.state.addCommonRmedialQuestion} handleAddCommonRemedialQuestion={this.handleCommonRemedialQuestion} />}
							{!this.isStudentUser &&
								<PreviousYearQuestion
									questionId={content[selectedQuestionIndex - 1] ? c.paragraphQuestionId : ''}
									subjects={content[selectedQuestionIndex - 1] ? _.isUndefined(c.subjects) ? [] : c.subjects : []}
									isDisable={(content.masterVariationQuestionId) ? true : false}
								/>
							}
						</MyPATExpansionPanel>

						: ''}

				{!this.isStudentUser &&
					<AddExtraTags
						formData={formData.tags}
						handleFormChange={this.handleTagsFormChange.bind(this)}
						defaultExpanded={true}
						error={formDataError['tags'].error}
						errorText={formDataError['tags'].errorText}
						contentType={type}
						tag={tag}
						openFeedback={openFeedback}
						addFeedback={this.addFeedback}
						replyFeedback={this.replyFeedback}
						closeFeedback={this.closeFeedback}
						resolveFeedback={this.resolveFeedback}
						clickedfeedbackData={clickedfeedbackData}
						addNewFeedback={this.addNewFeedback}
						authorType={this.props.authorType}
						isDisable={(!editRights.includes('tags')) ? true : false}
						activeValidationFeedbackSection={activeValidationFeedbackSection}
						activeValidationFeedbackData={activeValidationFeedbackData}
						handleAddCommentInFeedback={handleAddCommentInFeedback}
						createNewValidationFeedback={createNewValidationFeedback}
					/>
				}



				{
					isLock ? (
						<ModalComponent
							component={() => (
								<>
									<MuiDialogContent className={classes.paddingSet}>
										<div className={classes.popupBlock}>
											<b className={classes.attentionTitle}>Attention</b>
											<img src="https://mypat-v2-prod.s3-us-west-2.amazonaws.com/webcontent/cms/attention.png" alt="Attention" />
											<p>{message}</p>
										</div>
										<div style={{ 'textAlign': 'right' }}>
											<Button autoFocus
												variant="contained"
												color="primary"
												onClick={this.handleClose}>
												OK
											</Button>
										</div>
									</MuiDialogContent>
									<MuiDialogActions></MuiDialogActions>
								</>
							)}
						/>
					) : ''
				}
			</>
		);
	}
};


const mapStateToProps = (state: any) => ({
	isValidAttempts: state.questionCreate.isValidAttempts,
	setIdealTime: state.questionCreate.idealTime,
	editRights: _.get(state, 'questionCreate.editRights', []),
	isQuestionUpdated: _.get(state, "mylibraryData.content.isQuestionUpdated", false),
	relevantExams: state.questionCreate.relevantExams,
	matrixOptionContent: state.questionCreate.matrixOptionContent,
	optionsContent: state.questionCreate.optionsContent,
	validations: state.questionCreate.validations,
	questionSpecialPurposes: state.questionCreate.specialPurposes,


});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	eventFired,
	paragraphEventFired,
	updateContent: contentActions.updateContent,
	initialiseNoOfStepWiseSolutionForQuestions: questionActions.initialiseNoOfStepWiseSolutionForQuestions,
	addNewFeedback: addNewFeedback,
	resolveFeedback: resolveFeedback,
	replyFeedback: replyFeedback,
	setValidations: questionActions.setValidations,
	setRemedialInitialState: remedialQuestionActions.setInitialState
}, dispatch);


// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ParagraphCreate));